import React, { useState, useEffect } from 'react';

const TextToSpeech = () => {
  const [inputText, setInputText] = useState('');
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);

  useEffect(() => {
    // Fetch available voices when the component mounts
    const fetchVoices = () => {
      const availableVoices = speechSynthesis.getVoices();
      setVoices(availableVoices);

      // Find the Microsoft Zira voice
      const ziraVoice = availableVoices.find(
        (voice) => voice.name === 'Microsoft Zira - English (United States)'
      );

      if (ziraVoice) {
        setSelectedVoice(ziraVoice);
      } else {
        // If Zira voice is not available, select the first voice
        setSelectedVoice(availableVoices[0]);
      }
    };

    // Event listener for voiceschanged event
    speechSynthesis.addEventListener('voiceschanged', fetchVoices);

    return () => {
      // Cleanup the event listener when the component unmounts
      speechSynthesis.removeEventListener('voiceschanged', fetchVoices);
    };
  }, []);

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleVoiceSelection = (event) => {
    const selectedVoiceId = event.target.value;
    const voice = voices.find((v) => v.voiceURI === selectedVoiceId);
    setSelectedVoice(voice);
  };

  const handleSpeechSynthesis = () => {
    if (!selectedVoice) {
      console.log('No voice selected.');
      return;
    }

    const utterance = new SpeechSynthesisUtterance(inputText);
    utterance.voice = selectedVoice;
    utterance.rate = 1.2; // Speech rate (0.1 to 10)
    utterance.pitch = 1; // Speech pitch (0 to 2)

    speechSynthesis.speak(utterance);
  };

  return (
    <div>
      <input type="text" value={inputText} onChange={handleInputChange} />
      <select onChange={handleVoiceSelection}>
        {voices.map((voice) => (
          <option key={voice.voiceURI} value={voice.voiceURI}>
            {voice.name}
          </option>
        ))}
      </select>
      <button onClick={handleSpeechSynthesis}>Speak</button>
    </div>
  );
};

export default TextToSpeech;
